import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "ml-1 text-color-secondary"
}

import { computed, toRefs } from 'vue';
interface PropsInterface {
  code: string | null;
  classes?: string;
  seeCode?: boolean;
  dividerColor?: string;
  dividerWidth?: string;
  dividerHeight?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DisciplineIcon',
  props: {
    code: { default: '' },
    classes: { default: '' },
    seeCode: { type: Boolean, default: false },
    dividerColor: { default: '#d4d9d9' },
    dividerWidth: { default: '3px' },
    dividerHeight: { default: '16px' }
  },
  setup(__props: any) {

const props = __props;

const { code, dividerColor, dividerWidth, dividerHeight } = toRefs(props);

const iconName = computed(() => {
  switch (props.code) {
    case 'SL':
      return 'record_voice_over';
    case 'OT':
      return 'work';
    case 'PT':
      return 'emoji_people';
    case 'SWC':
      return 'handshake';
    case 'PSY':
      return 'psychology';
    case 'BI':
      return 'emoji_objects';
    case 'SPED':
      return 'school';
    case 'EDDIAG':
      return 'assessment';
    default:
      return 'category'; // generic fallback so unmapped disciplines never render blank
  }
});

const classStyles = computed<string>(() => {
  return `padding-left:3px;  border-left-style: solid; border-left-width: ${dividerWidth.value}; border-left-color: ${dividerColor.value}; height: ${dividerHeight.value}`;
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(__props.classes),
      style: _normalizeStyle(classStyles.value)
    }, null, 6),
    _createVNode(_component_Icon, {
      name: iconName.value,
      style: {"color":"#7e78d2"}
    }, null, 8, ["name"]),
    (__props.seeCode)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(code)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})